import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.project.drawing.add');
import { OnInit, Input, Output, EventEmitter, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

@Component({
    selector: 'wiz-component-project-drawing-add',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.project.drawing.add/view.scss */
:host {
  display: block;
}`],
})
export class ComponentProjectDrawingAddComponent implements OnInit {
    @Input() isOpen: boolean = false;
    @Input() projectId: string = '';
    @Output() onClose = new EventEmitter<void>();
    @Output() onUploaded = new EventEmitter<void>();

    public files: File[] = [];
    public isUploading: boolean = false;
    public uploadProgress: number = 0;

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() { }

    public close() {
        this.files = [];
        this.uploadProgress = 0;
        this.onClose.emit();
    }

    public async onFileChange(event: any) {
        const fileList = event.target.files;
        if (!fileList?.length) return;

        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            const isImage = file.type.startsWith('image/');
            const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
            if (!isImage && !isPdf) continue;
            this.files.push(file);
        }
        await this.service.render();
    }

    public async removeFile(index: number) {
        this.files.splice(index, 1);
        await this.service.render();
    }

    public formatFileSize(bytes: number): string {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    public async upload() {
        if (this.files.length === 0) return;

        this.isUploading = true;
        this.uploadProgress = 0;
        await this.service.render();

        const fd = new FormData();
        fd.append('project_id', this.projectId);
        for (const file of this.files) {
            fd.append('file[]', file);
        }

        try {
            const result: any = await new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('POST', wiz.url('upload_drawings'));

                xhr.upload.onprogress = (e: ProgressEvent) => {
                    if (e.lengthComputable) {
                        this.uploadProgress = Math.round((e.loaded / e.total) * 100);
                        this.service.render();
                    }
                };

                xhr.onload = () => {
                    try {
                        const data = JSON.parse(xhr.responseText);
                        if (xhr.status === 200) {
                            resolve(data);
                        } else {
                            reject(new Error(data.message || data.data || '업로드 실패'));
                        }
                    } catch {
                        reject(new Error('응답 처리 실패'));
                    }
                };

                xhr.onerror = () => reject(new Error('네트워크 오류'));
                xhr.send(fd);
            });

            this.files = [];
            this.isUploading = false;
            this.uploadProgress = 0;
            await this.service.render();
            this.onUploaded.emit();
            this.onClose.emit();
            await this.service.alert.show({
                title: '성공',
                message: '도면이 업로드되었습니다.',
                status: 'success',
                action: '확인',
                cancel: false
            });
        } catch (e: any) {
            this.isUploading = false;
            this.uploadProgress = 0;
            await this.service.render();
            await this.service.alert.show({
                title: '오류',
                message: e.message || '업로드에 실패했습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
        }
    }
}

export default ComponentProjectDrawingAddComponent;